module.exports = __webpack_public_path__ + "static/assets/e8b661a1248933bed37b8800c4707f12.png";